import React from 'react';

const Footer = ({ companyName, social }) => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} {companyName}. All rights reserved. | Built by {companyName}.</p>
        
      </div>
    </footer>
  );
};

export default Footer; // 🔥 CRITICAL: Default export